import { KeyboardArrowRight } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import Zoom from '@mui/material/Zoom';

export default function SubstepForwardButton({substepForward, lastSubstep, substepIsCompleted, lastStep}){
    return (
        <div className="wrapper" id='substepForwardWrapper'>
            <Tooltip title="Nächste Seite" TransitionComponent={Zoom} arrow>
                <IconButton 
                size="small" 
                onClick={substepForward}
                disabled={(lastSubstep && lastStep) || !substepIsCompleted}
                color="primary"
                >
                    <KeyboardArrowRight />
                </IconButton>
            </Tooltip>
        </div>
        
    )
}